export default __webpack_public_path__ + "static/acessibilidade-77f883c51ed1ee3b923bcec2defe7150.png";